import { Accordion } from "flowbite-react"
  const MobileappFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the benefits of a mobile app for my business?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Mobile apps have become essential for businesses in todays digital world. They are a popular option for businesses of all sizes because they can boost sales, increase customer engagement, streamline operations, and improve brand visibility. Also, mobile apps can help businesses build long-term relationships by making it easier for customers to interact with them.<br></br>
                  They can also increase customer loyalty and provide helpful information about customer behaviour and preferences. Furthermore, mobile apps can help businesses save time and resources by automating workflows and delivering real-time tracking. If you are looking to take your business to the next level, investing in a mobile app can be a game-changer.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Which platform should I choose for mobile app development, iOS or Android?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Mobile apps offers a wide range of benefits such as a weightless codebase, easy upgrade, powerful, excellent documentation, faster development, adaptability, and great scalability compared to other technologies.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> How much does it cost to develop a mobile app?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Mobile apps framework can help you develop a variety of web applications, including- <br/>
                  <ul className="list mb-0 mt-3">
                      <li>Team collaboration applications</li>
                      <li>Real-time applications</li>
                      <li>Streaming applications</li>
                      <li>Simple web applications</li>
                      <li>Large scale applications</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What features can we integrate into your mobile apps?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Various huge brands that have created real-time apps using the Mobile apps framework for their business are Alibaba, IBM, Apple, Google, BMW, Adobe, Trivago, Behance, Bitpanda, Louis Vuitton, Wizz Air, UpWork, Netflix, Euronews, Nintendo, and others.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the technology stacks used for mobile applications in 2023?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  The cost of your project depends on various factors such as the intricacy of your app, the technical expertise of programmers, the experience of developers, features to integrate, total development hours, and more. Please share your exact project requirements so that our team can revert with a project quote. 
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default MobileappFAQ
